import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ControlComponent } from './components/control/control.component';
import { CrearControlComponent } from './components/crear-control/crear-control.component';
import { EditControlComponent } from './components/edit-control/edit-control.component';


const routes: Routes = [
   
        { path: '', component: ControlComponent },
        { path: 'crear', component: CrearControlComponent },
        { path: 'edit/:id', component: EditControlComponent },
    


    
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppControlRoutingModule {}
